import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { TreeTable } from "primereact/treetable";
import CardSeplag from "../../../../components/CardSeplag";

import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import RotuloSeplag from "../../../../components/RotuloSeplag";
import { carregarArvoreMonitoraComFiltro } from "../../../../service/ArvoreMonitora";

const ProrrogacaoMonitora = ({ exercicio }) => {
  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [cDadosProgramas, setCDadosProgramas] = useState([]);
  const [uoSelecionada, setUoSelecionada] = useState([]);
  const [programaSelecionado, setProgramaSelecionado] = useState([]);

  let defaultArvoreMonitora = {
    arvorePtaMonitoras: cDadosArvore,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
    programas: cDadosProgramas,
  };

  useEffect(() => {
    let filtro = {
      idenExercicio: exercicio.idenExercicio,
      idenOrgao: null,
      idenUo: null,
      idenPrograma: null,
    };
    carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
      setCDadosOrgaos(res.orgaoFiplans);
    });
  }, []);

  const onChangeOrgao = async (e) => {
    setOrgaoSelecionado(e.value);
    setUoSelecionada([]);
    setProgramaSelecionado([]);
    setCDadosUOs([]);
    setCDadosProgramas([]);
    setCDadosArvore([]);

    let filtro = {
      idenExercicio: exercicio.idenExercicio,
      idenOrgao: e.value.idenOrgao,
      idenUo: null,
      idenPrograma: null,
    };
    await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
      setCDadosUOs(res.unidadeOrcamentarias);
    });
  };

  const onChangeUo = async (e) => {
    setUoSelecionada(e.value.idenUo);
    let filtro = {
      idenExercicio: exercicio.idenExercicio,
      idenOrgao: orgaoSelecionado.idenOrgao,
      idenUo: e.value.idenUo,
      idenPrograma: null,
    };

    await carregarArvoreMonitoraComFiltro(filtro, defaultArvoreMonitora).then((res) => {
      setCDadosProgramas(res.programas);
    });
  };

  return (
    <CardSeplag>
      <div className="p-fluid grid">
        <div className="field col-12 md:col-4">
          <RotuloSeplag nome="Órgão" cols="12 4">
            <Dropdown
              emptyMessage="Dados não encontrados"
              emptyFilterMessage="Opção não encontrada"
              id="selOrgao"
              value={orgaoSelecionado}
              options={cDadosOrgaos}
              onChange={onChangeOrgao}
              optionLabel="descricaoFiplan"
              placeholder="Selecione um Órgão"
            />
          </RotuloSeplag>
        </div>
        <div className="field col-12 md:col-4">
          <RotuloSeplag nome="U.O" cols="12 4">
            <Dropdown
              emptyMessage="Dados não encontrados"
              emptyFilterMessage="Opção não encontrada"
              id="selUO"
              value={uoSelecionada}
              options={cDadosUOs}
              onChange={onChangeUo}
              optionLabel="descricaoFiplan"
              placeholder="Selecione uma U.O."
            />
          </RotuloSeplag>
        </div>
      </div>

      <DataTable
        header={"Itens Monitoráveis"}
        value={cDadosProgramas}
        responsiveLayout="scroll"
        className="p-datatable-striped"
      >
        <Column field="descricaoFiplan"></Column>
      </DataTable>

      {cDadosArvore.length > 0 && (
        <TreeTable emptyMessage="Dados não encontrados" value={cDadosArvore} lazy></TreeTable>
      )}
    </CardSeplag>
  );
};
export default ProrrogacaoMonitora;
